import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

const LINE_ITEM_LOYALTY_DISCOUNT = 'line-item/loyalty-discount';

const LineItemLoyaltyDiscountMaybe = props => {
  const { lineItems, intl } = props;

  const discountLine = lineItems.find(
    item => item.code === LINE_ITEM_LOYALTY_DISCOUNT && !item.reversal
  );

  return discountLine ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.loyaltyDiscount" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, discountLine.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemLoyaltyDiscountMaybe;
